export default __webpack_public_path__ + "static/media/561.a4f167c5.png";